<template>
  <div
    class="msg-screen -helper--flex align-center"
    :style="{ backgroundColor: userMessageContext.backDropColor || '' }"
    :class="
      userMessageContext.popupAlignmentClass
        ? userMessageContext.popupAlignmentClass
        : 'justify-center'
    "
    @click="handleClick"
  >
    <span v-if="userMessageContext.shouldShowDemiHeader" class="demi-header" />
    <component :is="activePopup" :popup-props="popupTypeProps" />
  </div>
</template>
<script>
export default {
  computed: {
    userMessageContext() {
      return this.$store.getters['errors/getUserMessage']
    },
    popupType() {
      return this.userMessageContext.popupType
    },
    popupTypeProps() {
      return this.userMessageContext.popupTypeProps
    },
    activePopup() {
      return () => import(`./${this.popupType}.vue`)
    },
  },
  methods: {
    handleClick() {
      if (
        ['DownloadLili', 'NewlyFormedBusiness', 'RequiredDocExample'].includes(
          this.popupType
        )
      ) {
        this.terminateUserMessage()
      }
    },
    terminateUserMessage() {
      this.$store.commit('errors/updateUserMessage', {
        isActive: false,
        popupType: '',
        popupAlignmentClass: 'justify-center',
      })
    },
  },
}
</script>

<style lang="css">
.demi-header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 56px;
  background-color: white;
  border-bottom: 1px solid #dfe2eb;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/components/globalUiComponents/userMessage/UserMessage.vue